module.exports = __webpack_public_path__ + "media/images/success/googleplay-e387b341debbab900454995fd0f8ddea.png";